import { render, staticRenderFns } from "./MarketManagerMenu.vue?vue&type=template&id=574e4396&scoped=true&"
import script from "./MarketManagerMenu.vue?vue&type=script&lang=js&"
export * from "./MarketManagerMenu.vue?vue&type=script&lang=js&"
import style0 from "./MarketManagerMenu.vue?vue&type=style&index=0&id=574e4396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e4396",
  null
  
)

export default component.exports